import React from 'react';
import ReactDOM from 'react-dom';
import './styles/config.scss';
import './styles/global.scss';
import './styles/famdim.scss';
import App from './App';

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root')
);
